const instagramPanel = document.querySelector('.instagram-panel');

if (instagramPanel) {
    const mainFadeTarget = instagramPanel.querySelector('.panel-fade-target');
    if (mainFadeTarget) {
        const fadeTargets = instagramPanel.querySelectorAll('[data-panel-fader]');
        const scrollListener = () => {
            closeNavScrollThrottle();
        };

        function startListening() {
            window.addEventListener('scroll', scrollListener);
        }

        function stopListening() {
            window.removeEventListener('scroll', scrollListener);
        }

        startListening();

        function isInViewport() {
            const rect = mainFadeTarget.getBoundingClientRect();
                if (rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
                    setTimeout( function() {
                        for (let fadeTarget of fadeTargets) {
                            fadeTarget.dataset.panelFader = 'true';
                        }
                    }, 500);
                    stopListening()
                }
        }
        const closeNavScrollThrottle = _throttle(isInViewport, 50, { leading: true, trailing: true });
    }
}

